import React, { FC } from 'react';

import ChevronLeft from './assets/chevron-left.inline.svg';

interface Props {
  onClick?: () => void;
  title?: string;
}

export const BackBtn: FC<Props> = ({ onClick, title = 'Back' }) => {
  return (
    <a
      onClick={onClick}
      role="button"
      className="inline-flex flex-row items-center text-ocean-blue hover:text-accent-orange fill-ocean-blue hover:fill-accent-orange"
    >
      <ChevronLeft />
      <span className="ml-4 block font-medium">{title}</span>
    </a>
  );
};

export default BackBtn;
